import { tns } from 'tiny-slider/src/tiny-slider'

window.sliders = [];

// Featured Content
function hasMoreSlidesThanItems(slider) {
    if (slider.slideCount > slider.items) {
        slider.container.closest(".wrapper").classList.add("initialized");
    } else {
        slider.container.closest(".wrapper").classList.remove("initialized");
    }
}

function updateFeaturedContentSliders() {
    Object.keys(window.sliders).forEach(function (key) {
        if (key.match(/featuredContent/g)) {
            hasMoreSlidesThanItems(window.sliders[key].getInfo());
        }
    });
}

let featuredContent = document.querySelectorAll('.ash-block.featured-content');
for (let index = 0; index < featuredContent.length; index++) {
    const element = featuredContent[index];
    window.sliders['featuredContent' + element.getAttribute("data-featured-content")] = tns({
		container: element.querySelector(":scope .slider"),
        items: 1,
        gutter: 40,
        edgePadding: 60,
        controls: false,
        navPosition: 'bottom',
				autoplay: true,
        autoplayTimeout: 8000,
				autoplayButtonOutput: false,
        loop: true,
				navContainer: element.querySelector('.dots'),
        responsive: {
            800: {
                items: 2,
                edgePadding: 70
            },
            1200: {
                items: 3,
                edgePadding: 80
            }
        },
        onInit: function (e) {
            hasMoreSlidesThanItems(e);
        }
	});
}
window.addEventListener("orientationchange", updateFeaturedContentSliders);
window.addEventListener("resize", updateFeaturedContentSliders);


// Galleries
let galleries = document.querySelectorAll('.ash-block.gallery.slider');
for (let index = 0; index < galleries.length; index++) {
	const element = galleries[index];
	window.sliders['gallery' + element.getAttribute("data-gallery")] = tns({
		container: element.querySelector(":scope .wrapper"),
		items: 1,
		gutter: 10,
		edgePadding: 60,
		controlsContainer: element.querySelector(":scope .controls"),
		nav: false,
        autoplay: true,
        autoplayTimeout: 8000,
		autoplayButtonOutput: false,
		loop: true,
		responsive: {
			480: {
				edgePadding: 90
            },
            640: {
				edgePadding: 120
            },
            800: {
				edgePadding: 150
			},
			960: {
				edgePadding: 180
            },
            1120: {
				edgePadding: 210
            },
            1280: {
				edgePadding: 240
            },
            1440: {
				edgePadding: 270
            },
            1600: {
				edgePadding: 300
            },
            1760: {
				edgePadding: 330
            },
            1920: {
				edgePadding: 360
			},
		}
	});
}


// Scrolling Testimonials
let scrollingTestimonials = document.querySelectorAll('.ash-block.scrolling-testimonials');
for (let index = 0; index < scrollingTestimonials.length; index++) {
	const element = scrollingTestimonials[index];
	window.sliders['scrollingTestimonial' + element.getAttribute("data-testimonial")] = tns({
		container: element.querySelector(":scope .slider"),
		items: 1,
		controlsContainer: element.querySelector(":scope .controls"),
		nav: false,
        autoplay: true,
        autoplayTimeout: 8000,
		autoplayButtonOutput: false,
		loop: true,
	});
}


// Text w/Media
let textMedia = document.querySelectorAll('.ash-block.text-media');
for (let index = 0; index < textMedia.length; index++) {
	const element = textMedia[index];
	window.sliders['textMedia' + element.getAttribute("data-text-media")] = tns({
		container: element.querySelector(":scope .slider"),
		items: 1,
		controls: false,
		navContainer: element.querySelector(":scope .navigation"),
        autoplay: true,
        autoplayTimeout: 8000,
		autoplayButtonOutput: false,
		loop: true,
	});
}